import { useMemo } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { type TInitCardApiContext } from '../../types/TCardApiContext';
import { type TCardContextData } from '../../types/TCardContextData';
import { CardContext } from '../CardContext';

import { CardLayoutContainer } from './containers/CardLayoutContainer';

type TCardContainerProps = TCardContextData & {
  initCardApi: TInitCardApiContext;
};

export const CardContainer = memoWithDisplayName<TCardContainerProps>(({ dealType, index, offer, initCardApi }) => {
  const cardContextData = useMemo(() => ({ dealType, index, offer }), [dealType, index, offer]);

  return (
    <CardContext cardContextData={cardContextData} initCardApi={initCardApi}>
      <CardLayoutContainer />
    </CardContext>
  );
}, 'CardContainer');
